"use client";
import { identity } from "./factory.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/core/factory/polymorphic-factory.tsx
function polymorphicFactory(ui) {
	const Component = ui;
	Component.withProps = (fixedProps) => {
		const Extended = (props) => /* @__PURE__ */ jsx(Component, {
			...fixedProps,
			...props
		});
		Extended.extend = Component.extend;
		Extended.displayName = `WithProps(${Component.displayName})`;
		return Extended;
	};
	Component.extend = identity;
	return Component;
}
//#endregion
export { polymorphicFactory };

//# sourceMappingURL=polymorphic-factory.mjs.map